import { ClienteModel } from "../cliente/cliente.model";
import { UsuarioModel } from "./../usuario/usuario.model";

export class RelatorioModel {
  id: number;
  name: String;
  ative: Boolean;
  showProperties: Boolean;
  searchLanguage: String;
  description: String;
  searchText: String;
  cliente: ClienteModel;
  authUsers: Array<UsuarioModel>;
  reportType: String;
  aliasRelatorio: Array<any>;
  selectsRelatorio: Array<any>;
  assuntoRelatorioId: number;
}



// WEBPACK FOOTER //
// /app/src/app/model/relatorio/relatorioModel.ts